import { render, staticRenderFns } from "./EditMultiPointModal.vue?vue&type=template&id=0ddc203c&scoped=true"
import script from "./EditMultiPointModal.vue?vue&type=script&lang=js"
export * from "./EditMultiPointModal.vue?vue&type=script&lang=js"
import style0 from "./EditMultiPointModal.vue?vue&type=style&index=0&id=0ddc203c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ddc203c",
  null
  
)

export default component.exports